/**
 * MUI sx style definitions for ManageWhitelistDomain component.
 */

/** Per-status chip colour map — keeps the column renderer free of if-chains */
export const DOMAIN_STATUS_STYLES = {
  Whitelisted: { backgroundColor: "#e8f5e9", color: "#2e7d32" },
  PENDING:     { backgroundColor: "#fff8e1", color: "#f57c00" },
  ACTIVE:      { backgroundColor: "#cce5ce", color: "#05962e" },
  ONBOARDED:   { backgroundColor: "#cce5ce", color: "#05962e" },
  INACTIVE:    { backgroundColor: "#f0bcb6", color: "#f40c0c" },
  UPLOADED:    { backgroundColor: "#e3f2fd", color: "#1565c0" },
  Blocked:     { backgroundColor: "#ffebee", color: "#c62828" },
};

export const manageWhitelistDomainStyles = {
  pageHeaderRow: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1,
    mb: 1,
  },

  actionButtonsStack: { flexWrap: "wrap", gap: 1 },

  uploadButton: {
    color: "#1976d2",
    borderColor: "#1976d2",
    "&:hover": { color: "#1976d2", borderColor: "#1976d2", backgroundColor: "transparent", boxShadow: "none" },
  },

  whitelistButton: {
    backgroundColor: "#2e7d32",
    color: "#fff",
    "&:hover": { backgroundColor: "#2e7d32", color: "#fff", boxShadow: "none" },
  },

  removeWhitelistButton: {
    backgroundColor: "#d32f2f",
    color: "#fff",
    "&:hover": { backgroundColor: "#d32f2f", color: "#fff", boxShadow: "none" },
  },

  summaryCard: {
    borderRadius: 2,
    height: 122,
    border: "1px solid #EAECF0",
    boxShadow: "0 2px 10px rgba(16, 24, 40, 0.06)",
  },

  summaryCardContent: { p: 1.5, "&:last-child": { pb: 1.5 } },

  summaryCardTitle: {
    fontSize: 11,
    color: "#667085",
    letterSpacing: 0.4,
    fontWeight: 600,
  },

  summaryCardValue: { mt: 0.5, fontSize: 26, fontWeight: 700, lineHeight: 1.1 },

  summaryProgressBar: { mt: 1, height: 6, borderRadius: 999, backgroundColor: "#EEF2F6" },

  summaryCardPercent: { mt: 0.75, fontWeight: 600, fontSize: 12, color: "#475467" },

  skeletonProgressBar: { mt: 1, height: 6, borderRadius: 999 },

  gridToolbarRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 1,
  },

  searchField: { width: 260 },

  outlinedBlueButton: {
    color: "#1976d2",
    borderColor: "#1976d2",
    "&:hover": { borderColor: "#1976d2", backgroundColor: "transparent" },
  },

  gridWrapper: { position: "relative" },

  statusChip: { fontWeight: 600, borderRadius: "8px", maxWidth: "100%" },

  requestedByCell: { display: "flex", flexDirection: "column", justifyContent: "center" },

  requestedByName: { fontSize: 13 },

  requestedByEmail: { fontSize: 12, color: "#98A2B3" },

  requestDateText: { fontSize: 13 },
};
